const E = {
  // Row 1 from Brand Guide
  SPACE_BLUE: "#08002B",
  DEEP_BLUE: "#24176D",
  HORIZON_BLUE: "#501FFF",
  // Primary
  ULTRA_SOFT_VIOLET: "#6C54F0",
  DUSK: "#A497FF",
  NEBULA: "#E4DFFF",
  // Row 2 from Brand Guide
  SUN: "#EEAB38",
  STAR: "#F1C871",
  DAWN: "#F3DDA9",
  CELESTIAL_BLUE: "#3D7CF1",
  SKY_BLUE: "#6E9EFF",
  CLOUD_BLUE: "#DFE7F6",
  // Row 3 from Brand Guide
  BLACK: "#000000",
  GREY_A: "#80808A",
  GREY_B: "#BAB9C9",
  GREY_C: "#E4E3E9",
  WHITE: "#FFFFFF",
  // Not in Brand Guide
  ERROR: "#ED4245",
  WARNING: "#FEE75C",
  SUCCESS: "#00CC99"
}, a = {
  /* fonts */
  fontFamily: {
    headline: '"Ginto Nord"',
    body: '"Space Grotesk"',
    button: '"Space Mono"',
    subhead: '"Space Mono"',
    headlineFallback: "sans-serif",
    bodyFallback: "sans-serif",
    buttonFallback: "monospace",
    subheadFallback: "monospace"
  },
  /* colors */
  // semantic colors. These should be used where possible
  primary: E.HORIZON_BLUE,
  primaryDark: E.DEEP_BLUE,
  primary50: E.NEBULA,
  primary100: "#dcd2ff",
  primary200: "#b9a5ff",
  primary250: "#a88fff",
  primary300: "#8562ff",
  primary400: E.ULTRA_SOFT_VIOLET,
  // '#734cff',
  primary500: E.HORIZON_BLUE,
  primary600: "#4019cc",
  primary700: "#301399",
  primary750: E.DEEP_BLUE,
  primary800: "#18094c",
  primary900: "#100633",
  primary950: E.SPACE_BLUE,
  secondary: E.DUSK,
  secondaryDark: E.ULTRA_SOFT_VIOLET,
  secondaryLight: E.NEBULA,
  accent: E.STAR,
  accentDark: E.SUN,
  accentLight: E.DAWN,
  // MAYBE REMOVE
  darkBackground: E.SPACE_BLUE,
  black: E.BLACK,
  neutralDark: E.GREY_A,
  neutral: E.GREY_B,
  neutralLight: E.GREY_C,
  white: E.WHITE,
  error: E.ERROR,
  warning: E.WARNING,
  success: E.SUCCESS,
  info: E.CELESTIAL_BLUE,
  // colors straight from color palette. These should be avoided where possible
  _spaceBlue: E.SPACE_BLUE,
  _deepBlue: E.DEEP_BLUE,
  _horizonBlue: E.HORIZON_BLUE,
  _ultraSoftViolet: E.ULTRA_SOFT_VIOLET,
  _dusk: E.DUSK,
  _nebula: E.NEBULA,
  _sun: E.SUN,
  _star: E.STAR,
  _dawn: E.DAWN,
  _celestialBlue: E.CELESTIAL_BLUE,
  _skyBlue: E.SKY_BLUE,
  _cloudBlue: E.CLOUD_BLUE,
  _greyA: E.GREY_A,
  _greyB: E.GREY_B,
  _greyC: E.GREY_C
};
export {
  a as t
};
